import { render, staticRenderFns } from "./LetterForPayment.vue?vue&type=template&id=6cb70cb6&scoped=true&"
import script from "./LetterForPayment.vue?vue&type=script&lang=js&"
export * from "./LetterForPayment.vue?vue&type=script&lang=js&"
import style0 from "./LetterForPayment.vue?vue&type=style&index=0&id=6cb70cb6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb70cb6",
  null
  
)

export default component.exports